/* eslint-disable no-unused-vars */
import ReactDOM from 'react-dom';
import App from './App';

import './index.css';

declare global {
  interface Window {
    fcWidget: any;
    Cypress: any;
    saveAsPNG: () => Promise<void>;
  }
}

window.addEventListener('resize', () => {
  const widthScreen = document.body.clientWidth;
  sessionStorage.setItem(
    'modeScreen',
    widthScreen >= 920 ? 'desktop' : 'mobile'
  );
});

ReactDOM.render(<App />, document.getElementById('root'));
